import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { portalJwtUrl } from '../configuration';

import useOidcAccessToken from './useOidc';

export default function usePortalAccessToken(): UseQueryResult<string> {
  const { accessToken: oidcAccessToken } = useOidcAccessToken();
  return useQuery({
    enabled: Boolean(oidcAccessToken),
    queryKey: ['portalAccessToken'],
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      const res = await fetch(`${portalJwtUrl}clients/access`, {
        headers: {
          Authorization: `Bearer ${oidcAccessToken}`,
        },
      });
      const data = await res.json();
      return data.token as string;
    },
  });
}
